<div class="grid-x grid-margin-x">
  <div class="cell small-12">
      <label>Context Target for Permit ID:
        <input type="text" [(ngModel)]="seConfiguration.contextTargetForPermitId" />
    </label>
</div>